module.exports = __webpack_public_path__ + "media/images/wine-b6958de22231b9367819c9b05a130c5e.png";